import {clearPlanPickerPress} from "pricing/planPickerPress";
import {PAID_PLAN_IDS, type PaidPlanId, type PlanId} from "pricing/planCatalogue";

/**
 * A card pressed in the full table stacked on the first-month offer, on the path that must not leave
 * the page (an instant sender, whose tab is the live transfer): it only picks the tier in the offer's
 * own dialog. Answers that tier, or undefined for the free card, which the offer cannot sell.
 *
 * The table recorded the press for a checkout verdict, and here none follows, so the press is ended:
 * left waiting, the next unrelated checkout in the tab (the billing page, the command palette) took it
 * and was counted as this offer's checkout and payment (kitecorp/transferify-ui#2914 review).
 */
export function chooseStackedTier(planId: PlanId): PaidPlanId | undefined {
	clearPlanPickerPress();
	return PAID_PLAN_IDS.find(candidate => candidate === planId);
}
